import { createAction } from '@reduxjs/toolkit'

export const LimitReachedActions = {
  alert: createAction('LIMIT_REACHED_ALERT'),
}
